<template lang="pug">
.briq-multilanguage
  .flex.mb-S.header(v-show="showSecondColumn")
    .ml-header-col.w-full
      span.bold.ml-label.type-bold From: {{ defaultCulture }}
    .ml-header-col.w-full
      span.bold.ml-label.type-bold To:
      BriqMultiselect(
        data-test-id="culture-multiselect"
        v-if="cultures"
        :options="cultures"
        v-model="culture"
        display="DisplayName"
        required="required"
        selectLabel=""
        deselectLabel=""
        selectedLabel=""
        bindObject
        )
  .flex(:class="{ 'two-columns': showSecondColumn }")
    .ml-primary-col.w-full
      slot
    // do not remove secondary class, it's tightly coupled to logic
    .ml-secondary.ml-secondary-col.w-full(v-show="showSecondColumn")
      slot(name="secondary")
</template>

<script>
import { pipe, concat, map, join, forEach } from 'ramda'

export default {
  name: 'BriqMultilanguage',
  props: {
    translationFields: {
      type: Array,
      required: true,
    },
    defaultCulture: {
      type: String,
      required: true,
    },
    showSecondColumn: Boolean,
    cultures: Array,
    value: Object,
    nodesToHide: Array,
  },
  computed: {
    culture: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  mounted() {
    const inputs = this.$document.querySelectorAll(
      '.briq-multilanguage .ml-secondary .briq-form-element',
    )
    for (const node of inputs) {
      const label = node.querySelector('label')
      if (!this.translationFields.includes(label?.textContent?.trim())) node.classList.add('hidden')
    }
    if (this.nodesToHide && this.nodesToHide.length) {
      const extraSelector = pipe(
        map(concat('.briq-multilanguage .ml-secondary ')),
        join(', '),
      )(this.nodesToHide)
      forEach(node => node.classList.add('hidden'))(this.$document.querySelectorAll(extraSelector))
    }
  },
}
</script>

<style scoped lang="stylus">
.two-columns
  .ml-primary-col
    padding-right 10px
    border-right 1px solid #eee

  .ml-secondary-col
    padding-left 10px
    width 100%

.ml-header-col
  display flex
  align-items center

  .ml-label
    margin-right 10px
</style>

<style lang="stylus">
.briq-multilanguage .briq-multiselect
  margin-bottom 0
</style>
